import { useTranslation } from 'next-i18next';
import SupportDiscord from 'components/Layout/Support/SupportDiscord';
import SupportEmail from 'components/Layout/Support/SupportEmail';
import { ClockIcon } from 'images/svg';
import StartComputing from 'components/Layout/Home/StartComputing';
import PageHero from 'components/Layout/PageHero';

const ComputingContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="support-computing">
        <PageHero header={t('support.pageHero.pod.header')} page="home" />
        <div className="support-computing__faq">
          <h2>
            {t('support.pageHero.pod.description') || 'Live Support Options'}
          </h2>
          <div className="support-computing__faq-communication">
            <SupportDiscord
              header={t('support.supportDiscord.header')}
              description={t('support.supportDiscord.description')}
            >
              <div className="support-discord__footnotes">
                <ClockIcon />
                <span>{t('support.supportDiscord.footnotes')}</span>
              </div>
            </SupportDiscord>
            <SupportEmail email="help@simplepod.ai" />
          </div>
        </div>
      </div>
      <StartComputing />
    </>
  );
};

export default ComputingContent;
